import { render } from "./ZoneWizardZoneTypeStep.vue?vue&type=template&id=5ad8317c&scoped=true"
import script from "./ZoneWizardZoneTypeStep.vue?vue&type=script&lang=js"
export * from "./ZoneWizardZoneTypeStep.vue?vue&type=script&lang=js"

import "./ZoneWizardZoneTypeStep.vue?vue&type=style&index=0&id=5ad8317c&scoped=true&lang=less"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad8317c"]])

export default __exports__